/* eslint-disable object-curly-newline */
import React from 'react';
import styled from '@emotion/styled';

import { TextColor } from '../styles/colors';
import { mediaPhone, onlyTablet, minTablet, minDesktop } from '../styles/breakpoints';
import { HeadlineFont } from '../styles/fonts';

import DownloadMaterialButton from '../DownloadMaterialButton';
import H2 from '../H2';
import Stacheldraht from '../Stacheldraht';

import Gallery from './Gallery';

import PfeilImage from './Pfeil.svg';

import IMAGES from './images.json';

const StacheldrahtInfoTop = styled(Stacheldraht)`
  display: none;
  ${minDesktop} {
    display: block;
    margin-top: -20px;
    margin-bottom: 20px;
  }
`;

const Info = styled.p`
  ${HeadlineFont};
  font-size: 22px;
  line-height: 1.2;
  text-align: center;
  color: ${TextColor};
  transform: rotate(-3deg);
  padding-top: 80px;
  margin-left: auto;
  margin-right: auto;
`;

const Section = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: 1020px;
  margin-bottom: 90px;
`;

const DownloadAllContainer = styled.div`
  margin-top: 30px;
  text-align: center;
  margin-bottom: 30px;
`;

const DownloadAll = styled(DownloadMaterialButton)`
  padding: 15px;
  border-radius: 3px;
  text-align: center;
`;

const Title = styled(H2)`
  text-transform: uppercase;
  margin-top: 15px;
  margin-bottom: 18px;
`;

const Pfeil = styled.img`
  position: relative;
  top: 0;
  left: 50%;
  width: 35px;
  ${mediaPhone} {
    top: -10px;
    left: 66%;
    width: 48px;
  }
`;

const InfoContainer = styled.div`
  position: relative;

  margin-left: auto;
  margin-right: auto;

  max-width: 330px;
  ${onlyTablet} {
    max-width: 540px;
  }
  ${minTablet} {
    font-size: 18px;
  }
  ${minDesktop} {
    max-width: 400px;
    left: -20%;
    top: -130px;
    margin-bottom: -130px;
  }
`;

const SmartboardGallery = () => (
  <Section>
    <InfoContainer>
      <StacheldrahtInfoTop small />
      <Info>
        Hier k&ouml;nnen Sie Bilder zum Einsatz im Klassenraum herunterladen
      </Info>
      <Pfeil src={PfeilImage} />
    </InfoContainer>
    <Title>
      Smartboard-Galerie
    </Title>
    <Gallery images={IMAGES.map(({ caption, src, thumbnail, srcSet, orientation }) => ({
      src,
      thumbnail,
      srcSet,
      caption,
      orientation,
      useForDemo: true,
    }))}
    />
    <DownloadAllContainer>
      <DownloadAll
        label="Alle herunterladen"
        href="/downloads/Modebewusst_Smartboard_Bilder.zip"
        download="Modebewusst_Smartboard_Bilder.zip"
      />
    </DownloadAllContainer>
  </Section>
);

export default SmartboardGallery;



// WEBPACK FOOTER //
// ./src/components/SmartboardGallery/SmartboardGallery.js